import React from "react";
import { VStack } from "@chakra-ui/react";
import { Switch } from "components";
import { useCurrentCase } from "duck";
import { useUpdateAuthorizations } from "./duck";

const Authorizations: React.FC = () => {
  const authorizations = useCurrentCase(
    medicalCase => medicalCase.data.authorizations
  );
  const onChange = useUpdateAuthorizations();

  return (
    <VStack spacing={6}>
      {authorizations.map(authorization => (
        <Switch
          key={authorization.fakeId || authorization._id}
          isChecked={authorization.selected}
          label={authorization.condition}
          onChange={() => {
            onChange({ ...authorization, selected: !authorization.selected });
          }}
        />
      ))}
    </VStack>
  );
};

export default Authorizations;
